import React from "react";

import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

export default ({ children, onClick, tip, btnClassName, tipClassName, focusable, ariaLabel}) => (
  <Tooltip title={tip|| ""} className={tipClassName} placement="top">
    <IconButton onClick={onClick} className={btnClassName} focusable={focusable} aria-label={ariaLabel}>
      {children}
    </IconButton>
  </Tooltip>
);
